
        var result = require("!!../../../../node_modules/css-loader/index.js!./supplier.registration.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/registration/supplier.registration.component.css
// module id = 1212
// module chunks = 0